export default __webpack_public_path__ + "static/media/element_18.93dec833.webp";